import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { Pagination } from 'components/common';

interface Props {
  pages?: number;
}

const UsersPagination = ({ pages }: Props) => {
  const { pageState } = useReduxState();

  const router = useRouter();

  const handlePageChange = ({ page }: { page: number }) => {
    router.replace({ query: { ...router.query, page } });
  };

  return (
    <Pagination
      currentPage={router?.query?.page ? Number(router.query.page) : 1}
      numberOfPages={pages || pageState.pages}
      onPageChange={handlePageChange}
    />
  );
};

export default UsersPagination;
